import getAbsoluteURL from './getAbsoluteUrl';

export default function useOpenGraphImage(path) {
  const fullImageURL = getAbsoluteURL(`/og-images${path}.jpg`);
  return { seoImageURL: fullImageURL };
}
